module.exports = __webpack_public_path__ + "img/choir.cc5dd763.png";